/**
 * Minimal search fix: proxy all search buttons to theme's primary trigger,
 * keep drawer at body level, fix bar height when open.
 */
(function () {
  var TRIGGER = '[data-predictive-search-open-drawer]';

  function portalDrawer() {
    var drawer = document.getElementById('SearchDrawer');
    if (drawer && drawer.parentElement !== document.body) {
      document.body.appendChild(drawer);
    }
  }

  var MOBILE_DRAWER_HEIGHT = 60;

  function fixDrawerHeight() {
    if (!document.body.classList.contains('js-drawer-open-top')) return;
    var drawer = document.getElementById('SearchDrawer');
    if (!drawer) return;
    if (window.matchMedia('(max-width: 749px)').matches) {
      drawer.style.height = MOBILE_DRAWER_HEIGHT + 'px';
      return;
    }
    var header = document.querySelector('[data-header-section]');
    var height = Math.max(header ? header.offsetHeight : 0, 72);
    drawer.style.height = height + 'px';
  }

  function bindSearchProxy() {
    var primary = document.querySelector(TRIGGER);
    if (!primary) return;

    document.addEventListener(
      'click',
      function (e) {
        if (document.querySelector('.hero-video__menu-open')) return;
        var btn = e.target.closest(TRIGGER);
        if (!btn || btn === primary) return;
        e.preventDefault();
        e.stopPropagation();
        primary.click();
      },
      true
    );

    document.addEventListener(
      'click',
      function (e) {
        if (document.querySelector('.hero-video__menu-open')) return;
        if (!e.target.closest(TRIGGER)) return;
        window.setTimeout(fixDrawerHeight, 0);
        window.setTimeout(fixDrawerHeight, 120);
      },
      true
    );
  }

  function watchDrawerOpen() {
    var observer = new MutationObserver(function () {
      if (document.body.classList.contains('js-drawer-open-top')) {
        fixDrawerHeight();
      }
    });
    observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }

  function init() {
    portalDrawer();
    bindSearchProxy();
    watchDrawerOpen();
    window.addEventListener('resize', fixDrawerHeight);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
